// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #FFFFFF;
    /* color: #CCCCFF */
}
/* .detail-content {
    background-color: #F5F5F5;
    
    
} */

.indiv {
    margin-top: 20px; 
    background-color: #ffffff; 
    padding: 10px;
    border-radius: 20px
}

.first {
    margin: 50px; 
    background-color: #EDECF8;
    /* color: #d31717 */
}

.detailspace {
    height: 133px; 
    background-color: #ffffff; 
    z-index: 100;
}

.enrollpay {
    float: right; 
    width: 190px;
    margin-top: 72px; 
    margin-bottom: 4px;
}

.enrollpay2 {
    float: right; 
    width: 190px;
    margin-bottom: 7px;
    z-index: 45;
}
.enrollpay3 {
    float: right; 
    width: 190px;
  
}

.servicetag {
    cursor: pointer; 
    padding-top: 4px; 
    padding-bottom: 4px; 
    padding-left: 7px; 
    padding-right: 7px; 
    border-radius: 30px; 
    font-weight: 500;
}

@media (min-width: 100px) and (max-width: 293px){
    .detailspace {
        height: 220px; 
        background-color: #ffffff; 
        z-index: 100;
    }
    .enrollpay {
        float: right; 
        width: 190px;
        margin-top: 0px;
        margin-bottom: 4px;
    }
    
}

@media (min-width: 297px) and (max-width: 567px){
    .enrollpay {
        float: right; 
        width: 190px;
        margin-bottom: 4px;
        margin-top: 0px;
    }
    .detailspace {
        height: 190px; 
        background-color: #ffffff; 
        z-index: 100;
    }
    .indiv {
        margin-top: 10px; 
        background-color: #ffffff; 
        padding: 2;
        border-radius: 20px
    }

    .first {
        margin: 10px; 
       
    }
}


@media  (min-width: 1000px) and (max-width: 1150px) {
    .enrollpay {
        float: right; 
        width: 190px;
        margin-bottom: 4px;
        margin-top: 0px;
    }
    .detailspace {
        height: 190px; 
        background-color: #ffffff; 
        z-index: 100;
    }
}

@media (max-width:450px){
    .textsize{
        font-size: 16px;
    }
}












`, "",{"version":3,"sources":["webpack://./src/components/courseDetails.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;;;;GAIG;;AAEH;IACI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;QACb,yBAAyB;QACzB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;;AAEJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,yBAAyB;QACzB,UAAU;QACV;IACJ;;IAEA;QACI,YAAY;;IAEhB;AACJ;;;AAGA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":["body {\n    background-color: #FFFFFF;\n    /* color: #CCCCFF */\n}\n/* .detail-content {\n    background-color: #F5F5F5;\n    \n    \n} */\n\n.indiv {\n    margin-top: 20px; \n    background-color: #ffffff; \n    padding: 10px;\n    border-radius: 20px\n}\n\n.first {\n    margin: 50px; \n    background-color: #EDECF8;\n    /* color: #d31717 */\n}\n\n.detailspace {\n    height: 133px; \n    background-color: #ffffff; \n    z-index: 100;\n}\n\n.enrollpay {\n    float: right; \n    width: 190px;\n    margin-top: 72px; \n    margin-bottom: 4px;\n}\n\n.enrollpay2 {\n    float: right; \n    width: 190px;\n    margin-bottom: 7px;\n    z-index: 45;\n}\n.enrollpay3 {\n    float: right; \n    width: 190px;\n  \n}\n\n.servicetag {\n    cursor: pointer; \n    padding-top: 4px; \n    padding-bottom: 4px; \n    padding-left: 7px; \n    padding-right: 7px; \n    border-radius: 30px; \n    font-weight: 500;\n}\n\n@media (min-width: 100px) and (max-width: 293px){\n    .detailspace {\n        height: 220px; \n        background-color: #ffffff; \n        z-index: 100;\n    }\n    .enrollpay {\n        float: right; \n        width: 190px;\n        margin-top: 0px;\n        margin-bottom: 4px;\n    }\n    \n}\n\n@media (min-width: 297px) and (max-width: 567px){\n    .enrollpay {\n        float: right; \n        width: 190px;\n        margin-bottom: 4px;\n        margin-top: 0px;\n    }\n    .detailspace {\n        height: 190px; \n        background-color: #ffffff; \n        z-index: 100;\n    }\n    .indiv {\n        margin-top: 10px; \n        background-color: #ffffff; \n        padding: 2;\n        border-radius: 20px\n    }\n\n    .first {\n        margin: 10px; \n       \n    }\n}\n\n\n@media  (min-width: 1000px) and (max-width: 1150px) {\n    .enrollpay {\n        float: right; \n        width: 190px;\n        margin-bottom: 4px;\n        margin-top: 0px;\n    }\n    .detailspace {\n        height: 190px; \n        background-color: #ffffff; \n        z-index: 100;\n    }\n}\n\n@media (max-width:450px){\n    .textsize{\n        font-size: 16px;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
